/**
 * Shared capacity policy — used by both the browser client and the Vercel Function.
 * Pure function: no I/O, no DOM, no state.
 *
 * Keeping this in js/shared/ (imported from both js/ and api/) means that a change
 * to capacity logic only needs to happen in one place.
 */
import { CAPACIDADES } from './constants.js';

/**
 * Checks whether adding `personas` to the current occupancy stays within the
 * area's maximum capacity.
 *
 * @param {{ ocupacionActual: number, personas: number, area: string }} params
 * @returns {{ ok: boolean, remaining: number }}
 *   ok        — true if the booking can proceed
 *   remaining — seats still available after this booking (negative if over capacity)
 */
export function checkCapacity({ ocupacionActual, personas, area }) {
    const max = CAPACIDADES[area] || 0;
    const remaining = max - ocupacionActual - personas;
    return {
        ok: remaining >= 0,
        remaining,
    };
}
